import { render, staticRenderFns } from "./ActionEditPortingCancellation.vue?vue&type=template&id=15fb9082&scoped=true&"
import script from "./ActionEditPortingCancellation.vue?vue&type=script&lang=js&"
export * from "./ActionEditPortingCancellation.vue?vue&type=script&lang=js&"
import style0 from "./ActionEditPortingCancellation.vue?vue&type=style&index=0&id=15fb9082&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fb9082",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
